export enum UnrModalDismissEventEnum {
  Primary,
  Secondary
}
